angular.module('TetherApp').controller('ListenerPersonVariableController', [
	'$window',
	'$location',
	'$anchorScroll',
	function (
		$window,
		$location,
		$anchorScroll
	) {
		let self = this;
		self.personVariableData = [];

		self.init = function () {
			if(window.personVariableData != undefined) {
				angular.forEach(window.personVariableData, function( value, key ) {
					self.personVariableData.push(value);
				}, self);
			}
		};

		self.create = function () {
			data = {};

			data.id = null;
			data.key = self.newDataKey;
			data.value = self.newDataValue;

			if(!data.key || !data.value) {
				self.hasError = 1;
			} else {
				self.hasError = 0;

				self.personVariableData.push(
					data
				);

				self.newDataKey = null;
				self.newDataValue = null;
			}
		};

		self.delete = function(key) {
			self.personVariableData.splice(key, 1);
		};

	}
]);
